import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const AddressThunk = createAsyncThunk(
	"Address/AddressThunk",
	async (_, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;
		try {
			const url = `https://api.raj.com.sa/public/settings`;

			const res = await axios.get(url, {
				headers: {
					Locale: localStorage.getItem("language") || navigator?.languages?.[1],
				},
			});

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data?.data);
		}
	}
);
